import store from 'src/js/store';
import selectors from '../selectors';

const getCustomHtmlInstructionUrl = () => {
  const state = store.getState();

  return selectors.getCustomHtmlInstructionUrl(state);
};

export default getCustomHtmlInstructionUrl;
